import toast from "@/services/Notification";
import HTTP from "@/_helpers/http";
import { LEVERAGE__API } from "@/_helpers/urls";
import { LEVERAGE__MUTATIONS } from "../mutation-types";
import { LEVERAGE__ACTIONS } from "../action-types";
import router from "@/router";

// State
const state = {
    userleverages: [],
    allleverages: [],
};

//Getters
const getters = {};

//Mutations
const mutations = {
    [LEVERAGE__MUTATIONS.USERLEVERAGE](state, data) {
        state.userleverages = data;
    },
    [LEVERAGE__MUTATIONS.ALLLEVERAGES](state, data) {
        state.allleverages = data;
    },
};
// Actions
const actions = {
    async [LEVERAGE__ACTIONS.USERLEVERAGE]({ commit, state }, id) {
        try {
            const url = `${LEVERAGE__API.USERLEVERAGE}`;
            const response = await HTTP({
                trackProgress: true,
                loadingText: 'Processing...'
            }).get(url);

            if (response.status === 200) {
                commit(LEVERAGE__MUTATIONS.USERLEVERAGE, response.data);
                return;
            }
        } catch (error) {
            console.log(error);
        }
    },

    async [LEVERAGE__ACTIONS.ALLLEVERAGES]({ commit, state }, id) {
        try {
            const url = `${LEVERAGE__API.ALLLEVERAGES}`;
            const response = await HTTP({
                trackProgress: true,
                loadingText: 'Processing...'
            }).get(url);

            if (response.status === 200) {
                commit(LEVERAGE__MUTATIONS.ALLLEVERAGES, response.data);
                return;
            }
        } catch (error) {
            console.log(error);
        }
    },

    async [LEVERAGE__ACTIONS.UPDATELEVERAGE]({ commit, dispatch }, data) {
        try {
            const url = `${LEVERAGE__API.UPDATELEVERAGE}`;
            const response = await HTTP({
                trackProgress: true,
                loadingText: 'Processing...'
            }).post(url, data);

            if (response.status === 200) {
                dispatch(LEVERAGE__ACTIONS.USERLEVERAGE);

                toast.success("Leverage updated successfully");
                return true;
            }
        } catch (error) {
            console.log(error);
            toast.error(error.response?.data?.message || "Unable to update leverage");
            return false;
        }
    },

    async [LEVERAGE__ACTIONS.UPDATEMT5PASSWORD]({ commit, dispatch }, data) {
        try {
            const url = `${LEVERAGE__API.UPDATEMT5PASSWORD}`;
            const response = await HTTP({
                trackProgress: true,
                loadingText: 'Processing...'
            }).post(url, data);

            if (response.status === 200) {
                toast.success("Password updated successfully");
            }
        } catch (error) {
            console.log(error);
        }
    },
};

export default {
    namespaced: true,
    strict: process.env.NODE_ENV !== "production",
    state,
    getters,
    mutations,
    actions,
};
